export default __webpack_public_path__ + "static/media/pg-11.b5cfb317.jpg";